"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse = exports.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest = exports.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse = exports.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest = exports.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse = exports.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest = exports.LegacyPortalDashboardServiceGetUserAttributeCountsResponse = exports.LegacyPortalDashboardServiceGetUserAttributeCountsRequest = exports.LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse = exports.LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest = exports.LegacyPortalDashboardServiceGetEventSalesDetailsResponse = exports.LegacyPortalDashboardServiceGetEventSalesDetailsRequest = exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse = exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest = exports.LegacyPortalDashboardServiceGetEventRolesResponse = exports.LegacyPortalDashboardServiceGetEventRolesRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventRolesRequest
 */
class LegacyPortalDashboardServiceGetEventRolesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetEventRolesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetEventRolesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetEventRolesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetEventRolesRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetEventRolesRequest = LegacyPortalDashboardServiceGetEventRolesRequest;
LegacyPortalDashboardServiceGetEventRolesRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetEventRolesRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventRolesRequest";
LegacyPortalDashboardServiceGetEventRolesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventRolesResponse
 */
class LegacyPortalDashboardServiceGetEventRolesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.UserEventRole event_roles = 1;
         */
        this.eventRoles = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetEventRolesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetEventRolesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetEventRolesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetEventRolesResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetEventRolesResponse = LegacyPortalDashboardServiceGetEventRolesResponse;
LegacyPortalDashboardServiceGetEventRolesResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetEventRolesResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventRolesResponse";
LegacyPortalDashboardServiceGetEventRolesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_roles", kind: "message", T: legacy_portal_common_pb_1.UserEventRole, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest
 */
class LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string ticket_ids = 1;
         */
        this.ticketIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest = LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest";
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * チケットidを元にチケットの詳細情報を取得
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse
 */
class LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse = LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse";
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalIssuedTicketsSummary, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventSalesDetailsRequest
 */
class LegacyPortalDashboardServiceGetEventSalesDetailsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ダッシュボードで表示するイベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetEventSalesDetailsRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetEventSalesDetailsRequest = LegacyPortalDashboardServiceGetEventSalesDetailsRequest;
LegacyPortalDashboardServiceGetEventSalesDetailsRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetEventSalesDetailsRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventSalesDetailsRequest";
LegacyPortalDashboardServiceGetEventSalesDetailsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventSalesDetailsResponse
 */
class LegacyPortalDashboardServiceGetEventSalesDetailsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardEventSalesDetail event_sales_details = 1;
         */
        this.eventSalesDetails = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetEventSalesDetailsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetEventSalesDetailsResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetEventSalesDetailsResponse = LegacyPortalDashboardServiceGetEventSalesDetailsResponse;
LegacyPortalDashboardServiceGetEventSalesDetailsResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetEventSalesDetailsResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetEventSalesDetailsResponse";
LegacyPortalDashboardServiceGetEventSalesDetailsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_sales_details", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardEventSalesDetail, repeated: true },
    { no: 2, name: "bigquery_last_written_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest
 */
class LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ダッシュボードで表示するイベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 販売推移の集計粒度。未指定の場合は日単位で集計する。
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardSalesAggregationUnit aggregation_unit = 4;
         */
        this.aggregationUnit = legacy_portal_common_pb_1.LegacyPortalDashboardSalesAggregationUnit.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest = LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest;
LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest";
LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "aggregation_unit", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalDashboardSalesAggregationUnit) },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse
 */
class LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文日・チケット名ごとの販売枚数
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketSalesByOrderDate ticket_sales_by_order_date = 1;
         */
        this.ticketSalesByOrderDate = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse = LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse;
LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse";
LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_sales_by_order_date", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardTicketSalesByOrderDate, repeated: true },
    { no: 2, name: "bigquery_last_written_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetUserAttributeCountsRequest
 */
class LegacyPortalDashboardServiceGetUserAttributeCountsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ダッシュボードで表示するイベントID。複数イベントを指定した場合は、イベントを横断して購入者を重複なく集計する。
         *
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetUserAttributeCountsRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetUserAttributeCountsRequest = LegacyPortalDashboardServiceGetUserAttributeCountsRequest;
LegacyPortalDashboardServiceGetUserAttributeCountsRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetUserAttributeCountsRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetUserAttributeCountsRequest";
LegacyPortalDashboardServiceGetUserAttributeCountsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetUserAttributeCountsResponse
 */
class LegacyPortalDashboardServiceGetUserAttributeCountsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 年齢層・性別ごとのユーザー数
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardAgeGroupGenderCount age_group_gender_counts = 1;
         */
        this.ageGroupGenderCounts = [];
        /**
         * 性別ごとのユーザー数
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardGenderCount gender_counts = 2;
         */
        this.genderCounts = [];
        /**
         * 都道府県ごとのユーザー数
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardPrefectureCount prefecture_counts = 3;
         */
        this.prefectureCounts = [];
        /**
         * 通常注文の購入者総数に含まれる退会済み購入者数
         *
         * @generated from field: int32 deleted_purchaser_count = 4;
         */
        this.deletedPurchaserCount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetUserAttributeCountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetUserAttributeCountsResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetUserAttributeCountsResponse = LegacyPortalDashboardServiceGetUserAttributeCountsResponse;
LegacyPortalDashboardServiceGetUserAttributeCountsResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetUserAttributeCountsResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetUserAttributeCountsResponse";
LegacyPortalDashboardServiceGetUserAttributeCountsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "age_group_gender_counts", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardAgeGroupGenderCount, repeated: true },
    { no: 2, name: "gender_counts", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardGenderCount, repeated: true },
    { no: 3, name: "prefecture_counts", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardPrefectureCount, repeated: true },
    { no: 4, name: "deleted_purchaser_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest
 */
class LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ダッシュボードで表示するイベントID。複数イベントを指定した場合は、同じ設問ID・設問文・種別・設定済み選択肢の設問だけをイベント横断で集計する。
         *
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest = LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest;
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest";
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse
 */
class LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireQuestion questions = 1;
         */
        this.questions = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse = LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse;
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse";
LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "questions", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardTicketQuestionnaireQuestion, repeated: true },
    { no: 2, name: "bigquery_last_written_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * ページネーションで追加取得用リクエスト
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest
 */
class LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        /**
         * @generated from field: string question_id = 2;
         */
        this.questionId = "";
        /**
         * @generated from field: int32 limit = 5;
         */
        this.limit = 0;
        /**
         * @generated from field: int32 offset = 6;
         */
        this.offset = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest = LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest;
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest";
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "snapshot_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * ページネーションで追加取得用レスポンス
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse
 */
class LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswer answer_details = 1;
         */
        this.answerDetails = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse = LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse;
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse";
LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "answer_details", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalDashboardTicketQuestionnaireTextAnswer, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest
 */
class LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ダッシュボードで表示するイベントID 複数指定した場合は一つのファイルにまとめて出力する。
         *
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest = LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest;
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest";
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "from_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "to_date", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse
 */
class LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名。例: purchase_dashboard_rows_20260630.xlsx
         *
         * @generated from field: string file_name = 1;
         */
        this.fileName = "";
        /**
         * ファイル本体。
         *
         * @generated from field: bytes file = 2;
         */
        this.file = new Uint8Array(0);
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse = LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse;
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse";
LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map